import { render, staticRenderFns } from "./quotaHistory.vue?vue&type=template&id=129568d9&scoped=true&"
import script from "./quotaHistory.vue?vue&type=script&lang=js&"
export * from "./quotaHistory.vue?vue&type=script&lang=js&"
import style0 from "./quotaHistory.vue?vue&type=style&index=0&id=129568d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129568d9",
  null
  
)

export default component.exports